/* These ought to be env vars */
export const SEARCH_API_SUGGESTIONS_PATH = "/product/search/v1/suggestions";
export const COUNTRY_API_SELECTOR_PATH =
  "/web/countrymetadata/v1/countrySelector";
export const COUNTRY_API_WELCOME_MESSAGE_PATH =
  "/web/countrymetadata/v1/welcomeMessage";
export const COUNTRY_API_WELCOME_MAT_PATH =
  "/web/countrymetadata/v1/welcomeMat";
export const PAYMENT_PROVIDER_API_PATH =
  "/web/countrymetadata/v1/paymentProviders";
export const PREFERENCES_API_PATH = "/customer/preference/v1/preferences";



// WEBPACK FOOTER //
// ./api/constants.js